export const nbsp = '\u00a0';

export function camelCaseToSpaces(s: string): string {
  const stringWithSpaces = s.replace(/([A-Z])/g, ' $1').toLowerCase();
  return stringWithSpaces.charAt(0).toUpperCase() + stringWithSpaces.slice(1);
}

export function capitalize(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

export function ordinal(value: number): string {
  const j = value % 10,
    k = value % 100;
  if (j === 1 && k !== 11) {
    return `${value}st`;
  }
  if (j === 2 && k !== 12) {
    return `${value}nd`;
  }
  if (j === 3 && k !== 13) {
    return `${value}rd`;
  }
  return `${value}th`;
}

/**
 * Given a string (`original`), find the longest string among the `candidates`
 * that is equal to the start of the original string. If no match is found,
 * return `null`.
 *
 * Primary use case: given the current url and a list of candidates (nav links), find
 * which one of the path most closely matches the current url to mark it as active.
 *
 * @param original The string to find the longest substring of
 * @param candidates The candidates used to find the longest substring
 */
export function findLongestSubstringFromStart(
  original: string,
  candidates: string[]
): string | null {
  return candidates.reduce((longest, current) => {
    if (
      original.startsWith(current) &&
      (longest?.length ?? 0) < current.length
    ) {
      return current;
    } else {
      return longest;
    }
  }, null);
}
